import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { GuiaOneService } from '../../services/tour-mode/guia-one.service';

/**
 * D67/D71 — chips de ação do "Guia One", renderizados acima do input do chat. `GuiaOneService.acoes()`
 * já decide QUAIS ações mostrar e em que ordem; este componente só renderiza e despacha o clique —
 * nenhuma lógica de negócio mora aqui.
 */
@Component({
  selector: 'guia-chips',
  standalone: true,
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (guia.acoes().length) {
      <div class="guia-chips">
        @for (a of guia.acoes(); track a.id) {
          <button type="button" class="guia-chip" [attr.data-test]="'guia-' + a.id"
                  (click)="guia.executar(a.id)">
            <mat-icon>{{ a.icone }}</mat-icon>
            {{ a.rotulo }}
          </button>
        }
      </div>
    }
  `,
  styles: `
    :host { display: contents; }
    .guia-chips { display: flex; flex-wrap: wrap; gap: 8px; margin: 0 0 10px; }
    .guia-chip {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 7px 13px;
      border-radius: 999px;
      border: 1px solid var(--gray-500);
      background: var(--gray-100);
      color: var(--text-100);
      font-family: "Nunito Sans", sans-serif;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      transition: background 0.15s ease, transform 0.12s ease;
    }
    .guia-chip:hover { background: var(--gray-300); transform: translateY(-1px); }
    .guia-chip mat-icon {
      color: var(--ai-accent, var(--main-200));
      font-size: 16px;
      width: 16px;
      height: 16px;
    }
  `,
})
export class GuiaChipsComponent {
  readonly guia = inject(GuiaOneService);
}
